import Swal from 'sweetalert2'

export const swalAlertIsConfirm  = async (text) => {
    return await Swal.fire({
        title: text ,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirmar!'
    })
}

export const swalAlertError = async (text) => {
    return await Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: text,
    })
}

export const swalSuccessGeneral = async (title, text) => {
    return await Swal.fire({
        title: title,
        icon: 'success',
        text: text,
        showConfirmButton: false,
        timer: 1700
    })
}

export const swalLoading = async (title) => {
    return await Swal.fire({
        title: title,
        text: 'Esta acción puede durar unos segundos',
        timerProgressBar: true,
        onOpen: function() {
            Swal.showLoading()
        },
    })
}
